import { render } from "./TokenGate.vue?vue&type=template&id=ac7952bc&scoped=true&ts=true"
import script from "./TokenGate.vue?vue&type=script&lang=ts"
export * from "./TokenGate.vue?vue&type=script&lang=ts"

import "./TokenGate.vue?vue&type=style&index=0&id=ac7952bc&lang=scss&scoped=true"

import exportComponent from "/Users/n0x/w4_proj/zigmodu_ws/heysen_saas/site/datax/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac7952bc"]])

export default __exports__